import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromQRItem} from '@Hooks/poster-editor/useGetKeyFromQRItem';

interface QrBackgroundColorOptionProps {
  onClickColorFill(): void;
}

export function QrBackgroundColorOption({...props}: QrBackgroundColorOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const qrBackgroundColor = useGetKeyFromQRItem('qrBackgroundColor');

  if (!activeItem || !activeItem.isQRItem() || !qrBackgroundColor) {
    return null;
  }

  const getColorOptionForBackground = (): ReactElement<any> => {
    return (
      <ContextualMenuColorFillOption
        id="qr-background-color-option"
        label={window.i18next.t('pmwjs_color')}
        data={[
          {
            id: 'solid-color',
            color: getColorObjectArrayFromFillColor([qrBackgroundColor]),
          },
        ]}
        onClick={(): void => {
          props.onClickColorFill();
        }}
      />
    );
  };

  return getColorOptionForBackground();
}
